import { Autocomplete, TextField, FormControl, FormHelperText } from "@mui/material";
import { useFormContext } from "../form/IForm";

const IAutoComplete = ({ model, label, options = [], displayLabel = true, ...rest }) => {
  const form = useFormContext();

  const selectedValue =
    options.find((option) => option.key === form.values[model]) || null;

  return (
    <FormControl
      fullWidth
      error={form.touched[model] && Boolean(form.errors[model])}
    >
      <Autocomplete
        size="small"
        options={options}
        getOptionLabel={(option) => option.value || ""}
        value={selectedValue}
        onChange={(_, newValue) => {
          form.setFieldValue(model, newValue ? newValue.key : "");
        }}
        onBlur={() => form.setFieldTouched(model, true)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={displayLabel ? label : ""}
            variant="outlined"
          />
        )}
        {...rest}
      />
      {form.touched[model] && form.errors[model] && (
        <FormHelperText>{form.errors[model]}</FormHelperText>
      )}
    </FormControl>
  );
};

export default IAutoComplete;

